import { render, staticRenderFns } from "./LpuFeatures.vue?vue&type=template&id=469404b5&scoped=true&"
import script from "./LpuFeatures.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuFeatures.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuFeatures.vue?vue&type=style&index=0&id=469404b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469404b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('469404b5')) {
      api.createRecord('469404b5', component.options)
    } else {
      api.reload('469404b5', component.options)
    }
    module.hot.accept("./LpuFeatures.vue?vue&type=template&id=469404b5&scoped=true&", function () {
      api.rerender('469404b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuFeatures/LpuFeatures.vue"
export default component.exports